import { render, staticRenderFns } from "./DetailLoader.vue?vue&type=template&id=f1bca6c0&scoped=true&"
import script from "./DetailLoader.vue?vue&type=script&lang=ts&"
export * from "./DetailLoader.vue?vue&type=script&lang=ts&"
import style0 from "./DetailLoader.vue?vue&type=style&index=0&id=f1bca6c0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1bca6c0",
  null
  
)

export default component.exports